import { ApplicationConfig, importProvidersFrom, provideExperimentalZonelessChangeDetection, APP_INITIALIZER } from '@angular/core';
import { provideRouter, withViewTransitions } from '@angular/router';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideNativeDateAdapter } from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import { GamePluginRegistry, WheelPlugin, ScratchcardPlugin, GameBoardPlugin } from '@kanektech.com/game-engine';
import { appRoutes } from './app.routes';
import { IonicStorageModule } from '@ionic/storage-angular';

/**
 * Initialize game engine plugins
 */
function initializeGameEngine(registry: GamePluginRegistry) {
  return () => {
    // Register game plugins
    if (!registry.hasPlugin('wheel')) {
      registry.register(new WheelPlugin());
    }
    if (!registry.hasPlugin('scratchcard')) {
      registry.register(new ScratchcardPlugin());
    }
    if (!registry.hasPlugin('game-board')) {
      registry.register(new GameBoardPlugin());
    }
    console.log('[Experience App] Game engine initialized');
  };
}
export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(appRoutes, withViewTransitions()),
    provideAnimationsAsync(),
    provideExperimentalZonelessChangeDetection(),
    provideNativeDateAdapter(),
    importProvidersFrom(IonicStorageModule.forRoot()),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeGameEngine,
      deps: [GamePluginRegistry],
      multi: true,
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'outline',
        floatLabel: 'never',
        subscriptSizing: 'dynamic',
      },
    },
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
      useValue: {
        duration: 3000,
        verticalPosition: 'top'
      }
    }
  ],
};
